@if (!hidden) {
    <ds-card class="custom-marquee-card" [radius]="true" [border]="false" [elevated]="false">
        <ms-highlights-marquee [tiles]="tiles" [backgroundContainerConfig]="backgroundContainerConfig" [globalLinkConfig]="globalLinkConfig" />
    </ds-card>
}
